<template>
<div class="chapter">
<div class="inner_page">
<p class="h2"><b><i>Contents</i></b></p>
<p class="toc"><a href="#/html/9780292747388_07_in">Introduction</a></p>
<p class="toc"><a href="#/html/9780292747388_08_ch1">Mesquite: What Is It?</a></p>
<p class="toc"><span href="#/html/9780292747388_09_ch2" title="Link target outside of Sample">Predators of Mesquite</span></p>
<p class="toc"><span href="#/html/9780292747388_10_ch3" title="Link target outside of Sample">Mesquite in Texas and the Southwestern United States</span></p>
<p class="toc"><span href="#/html/9780292747388_11_ch4" title="Link target outside of Sample">The Uses of Mesquite</span></p>
<p class="toc"><span href="#/html/9780292747388_12_ch5" title="Link target outside of Sample">The Mesquite in Verse</span></p>
<p class="toc"><span href="#/html/9780292747388_13_ch6" title="Link target outside of Sample">Worldwide Aspects of <i>Prosopis</i></span></p>
<p class="toc"><span href="#/html/9780292747388_14_ch7" title="Link target outside of Sample">Texas Ebony—Mesquite’s Astonishing Cousin</span></p>
<p class="toc"><span href="#/html/9780292747388_15_ch8" title="Link target outside of Sample">Mesquite’s Future</span></p>
<p class="toc"><span href="#/html/9780292747388_16_app1" title="Link target outside of Sample">Appendix 1. The Genus <i>Prosopis</i> (Family Leguminosae/Fabaceae) and Its Species</span></p>
<p class="toc"><span href="#/html/9780292747388_17_app2" title="Link target outside of Sample">Appendix 2. Sources of Information</span></p>
<p class="toc"><span href="#/html/9780292747388_18_ref" title="Link target outside of Sample">References and Further Reading</span></p>
<p class="toc"><span href="#/html/9780292747388_19_index" title="Link target outside of Sample">Index</span></p>
<p> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780292747388_06_toc.vue?5f800104